import React from 'react'
import Typewriter from 'typewriter-effect'
import Linkedin from './Images/LinkedinB.png'
import insta from './Images/insta.png'
import fb from './Images/fb.png'
import git from './Images/github.png'
import mail from './Images/Email.png'

export default function Home() {
  return (
    <div id="Home" className='mainHome'>
      <div className='containerHome'>
            <h1 animate={{color: 'red'}} className="mx-10">Hi </h1>
            <h2 >
              
            <Typewriter
                onInit={(typewriter) => {
                  typewriter
                      .typeString('I am Adityaraj<br>')
                      .typeString('I am trying to become<br>')
                      .typeString('<span style="color: orange;">a Web Developer...😊</span>')
                      .pauseFor(1000)
                      .deleteChars(20)
                      .typeString('<span style="color:  orange;">a Java Developer...😊</span>')
                      .start();
                }}
            />

                
              </h2>
           
     
      </div>
      <div className='homeFloting'> 
        <lottie-player class="home__blob"
                                src="https://assets1.lottiefiles.com/packages/lf20_kkflmtur.json"
                                background="transparent" speed="1" loop autoplay></lottie-player>
      </div>
      
      {/* <h4 className='contactHome' style={{position:'absolute',bottom:50,left:175}}>Contact me</h4> */}
      <div className='webIds'>
      <a href="https://www.linkedin.com/in/adityaraj-patil-a5549727b/" target="blank" ><img align="center" src={Linkedin} alt="adityaraj patil" height="45" width="45" /></a><br/><br/>
      {/* <a href="https://instagram.com/adii152002" target="blank" ><img align="center" src={insta} alt="adii152002" height="40" width="40" /></a><br/>
      <a href="https://www.facebook.com/adityaraj.patil.792/" target="blank" ><img align="center" src={fb} alt="adii152002" height="40" width="40" /></a><br/> */}
      
      <a href="https://github.com/adityaraj152002" target="blank" ><img src={git} alt="adii152002" height="40" width="40"/></a><br/><br/>
      <a href='#Contact'><img align="center" src={mail} alt="adii152002" height="40" width="40" /></a><br/><br/>
      </div>
              
      
      {/* <img className='hImage' src={img1}/> */}
    </div>
  )
}
